import styles from "./About.module.css";
import Reveal from "./Reveal";
import { about } from "../data/content";

export default function About({ headless = false }) {
  return (
    <section id="about" className={`u-section ${styles.about}`}>
      <div className={`u-shell ${styles.grid}`}>
        <Reveal className={styles.intro}>
          {!headless && (
            <>
              <p className="u-eyebrow">{about.eyebrow}</p>
              <h2 className="u-h2">{about.heading}</h2>
            </>
          )}

          {about.paragraphs.map((text, i) => (
            <p key={i} className={styles.para}>
              {text}
            </p>
          ))}

          <blockquote className={styles.quote}>
            <span className={styles.quoteMark} aria-hidden="true">
              &ldquo;
            </span>
            {about.quote}
          </blockquote>
        </Reveal>

        <ul className={styles.principles}>
          {about.principles.map((principle, i) => (
            <Reveal
              as="li"
              key={principle.title}
              delay={i * 90}
              className={styles.principle}
            >
              {headless ? (
                <h2 className={styles.principleTitle}>{principle.title}</h2>
              ) : (
                <h3 className={styles.principleTitle}>{principle.title}</h3>
              )}
              <p className={styles.principleText}>{principle.text}</p>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
